import { render, staticRenderFns } from "./BusyTimeIndicatorThresholdPage.vue?vue&type=template&id=4d43f28c&scoped=true&"
import script from "./BusyTimeIndicatorThresholdPage.vue?vue&type=script&lang=js&"
export * from "./BusyTimeIndicatorThresholdPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43f28c",
  null
  
)

export default component.exports